<template>
    <div class="ml-4" style="display:contents">
        <dropdown class="mt-1" placement="bottom-end">
            <div class="flex items-center cursor-pointer select-none group">
            <div class="w-full text-sm md:text-md flex justify-start items-center-text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 whitespace-nowrap">
                 <icon class="w-5 h-5" :name="this.$page.props.locale " />
                 <span class="pl-2" style="text-transform: capitalize;">{{ this.$page.props.locale }}</span>
            </div>
            <icon class="w-7 h-7 group-hover:fill-indigo-600 fill-gray-700 focus:fill-indigo-600" name="cheveron-down" />
            </div>
            <div slot="dropdown" class="flex justify-start item-center mt-2 py-2 shadow-xl bg-white rounded text-sm">
                <inertia-link class="flex px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('language', [selectable_locale])" style="margin:3px">
                    <icon class="w-5 h-5" :name="selectable_locale" />
                    <span class="px-2" style="text-transform: capitalize;">{{ this.selectable_locale }}</span>
                </inertia-link>
                <inertia-link class="flex px-6 py-2 hover:bg-indigo-500 hover:text-white" :href="route('language', [selectable_locale1])">
                    <icon class="w-5 h-5" :name="selectable_locale1" />
                    <span class="px-2" style="text-transform: capitalize;">{{ this.selectable_locale1 }}</span>
                </inertia-link>
            </div>
        </dropdown>
    </div>
</template>
 
<script>
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
 
export default {
    components: {
        Icon,
        Dropdown
    },
 
    computed: {
        selectable_locale() {
            if(this.$page.props.locale == 'nl') {
                return 'en';
            }else if(this.$page.props.locale == 'fr'){
                return 'nl';
            }
            return 'nl'
        },
        selectable_locale1() {
           if(this.$page.props.locale == 'fr') {
                return 'en';
            }else if(this.$page.props.locale == 'nl'){
                return 'fr';
            }
            return 'fr'
        }
    }
}
</script>